<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="user-edit-tab-info">
    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
        <vs-input
          class="w-full mt-4"
          label="Senha"
          v-model="password1"
          type="password"
          name="password1"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('password1')">{{
          errors.first("password1")
        }}</span>
        <vs-input
          class="w-full mt-4"
          label="Confirme a senha"
          v-model="password2"
          type="password"
          name="password2"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('password2')">{{
          errors.first("password2")
        }}</span>
      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
            class="ml-auto mt-2"
            @click="updateUser"
            :disabled="!isFormValid"
            >Salvar</vs-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { baseApiUrl } from "@/global";
import { Validator } from "vee-validate";
import axios from "axios";
const dict = {
  custom: {
    password1: {
      required: "Por favor insira senha",
      alpha: "Your first name may only contain alphabetic characters",
    },
    password2: {
      required: "Por favor confirme a senha",
      alpha: "Your first name may only contain alphabetic characters",
    },
  },
};

// register custom messages
Validator.localize("en", dict);
export default {
  components: {
    vSelect,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      password1: "",
      password2: "",
    };
  },
  computed: {
    isFormValid() {
      return !this.errors.any() && this.password1 && this.password2;
    },
  },
  methods: {
    async updateUser() {
      const dontHaveErrors = !(await this.$validator.validateAll());
      if (dontHaveErrors) return;
      try {
        this.$vs.loading();
        this.user = {
          idUserCustomer: this.data.idUserCustomer,
          password1: this.password1,
          password2: this.password2,
        };
        this.$vs.loading();
        await axios.post(
          `${baseApiUrl}/userCustomers/updatePasswordUser`,
          this.user
        );
        this.$vs.loading.close();
        this.$router.push(`/usuarios`);
      } catch (error) {
        if (!error.response || !error.response.data) return;
        this.$vs.notify({
          title: "Ocorreu algum problema",
          text: error.response.data,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
  },
};
</script>
